/** Companies — create form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ENTITY_STATUS,
  createCompanySchema,
  type CreateCompanyInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "../projects/_shared";
import { FormGrid, SelectField, TextField } from "../projects/_form";

export function CompanyCreate() {
  const form = useForm<CreateCompanyInput, any, CreateCompanyInput>({
    resolver: zodResolver(createCompanySchema),
    defaultValues: {
      name: "",
      status: "active",
    },
    refineCoreProps: { resource: "companies", action: "create" },
  });

  const {
    refineCore: { formLoading },
    saveButtonProps,
    control,
  } = form;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="New Company" description="Create a company." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Company details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField
                  control={control}
                  name="name"
                  label="Name"
                  placeholder="Acme Construction"
                />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={ENTITY_STATUS}
                />
              </FormGrid>
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Creating…" : "Create Company"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default CompanyCreate;
